import { render, staticRenderFns } from "./Catalog-salesman.vue?vue&type=template&id=12049fcc"
import script from "./Catalog-salesman.vue?vue&type=script&lang=js"
export * from "./Catalog-salesman.vue?vue&type=script&lang=js"
import style0 from "./Catalog-salesman.vue?vue&type=style&index=0&id=12049fcc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports